import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { NzConfigService } from 'ng-zorro-antd/core/config';
import { NzNotificationDataOptions, NzNotificationService } from 'ng-zorro-antd/notification';

const HEADER_GAP = 8;
const MOBILE_BREAKPOINT = '(max-width: 1199px)';

@Injectable({ providedIn: 'root' })
export class ToastService implements OnDestroy {
    private breakpointSub: Subscription;

    constructor(
        private notification: NzNotificationService,
        private configService: NzConfigService,
        private breakpointObserver: BreakpointObserver,
    ) {
        this.breakpointSub = this.breakpointObserver.observe(MOBILE_BREAKPOINT).subscribe(state => {
            const nzTop = state.matches ? `${56 + HEADER_GAP}px` : `${100 + HEADER_GAP}px`;
            this.configService.set('notification', { nzTop });
        });
    }

    ngOnDestroy(): void {
        this.breakpointSub.unsubscribe();
    }

    success(message: string, title = '', options?: NzNotificationDataOptions): void {
        this.notification.success(title, message, options);
    }

    info(message: string, title = '', options?: NzNotificationDataOptions): void {
        this.notification.info(title, message, options);
    }

    warning(message: string, title = '', options?: NzNotificationDataOptions): void {
        this.notification.warning(title, message, options);
    }

    error(message: string, title = '', options?: NzNotificationDataOptions): void {
        this.notification.error(title, message, { nzDuration: 10000, ...options });
    }
}
